<template>
  <div>
    <h1 class="f1 mb4">Play offline</h1>
    <m-tile-container>
      <m-tile title="Classic" @click.native="$router.push({ name: 'setup.local.classic' })"></m-tile>
      <m-tile title="Arcade" @click.native="$router.push({ name: 'setup.local.custom' })"></m-tile>
      <m-tile title="stopwatch" @click.native="$router.push({ name: 'setup.local.stopwatch' })"></m-tile>
    </m-tile-container>
  </div>
</template>

<script>
export default {
  props: {},
};
</script>

<style>
</style>
